import Swiper, { A11y, Pagination } from 'swiper'

import 'swiper/css/pagination'

let swiperInstance = false

Swiper.use([A11y, Pagination])

const mediaQuery = window.matchMedia('(max-width:64em)')

function handleResizeChange (e) {
    // Check if the media query is true
    if (e.matches) {
        if (document.querySelector('[data-pillars-slider]')) {
            swiperInstance = new Swiper('[data-pillars-slider]', {
                slidesPerView: 1.5,
                spaceBetween: 32,
                centeredSlides: true,
                breakpoints: {
                    450: {
                        slidesPerView: 2,
                        spaceBetween: 64
                    },
                    700: {
                        slidesPerView: 3
                    }
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets'
                }
            })

            return
        }
    }

    if (swiperInstance) swiperInstance.destroy(true, true)
}

// Register event listener
mediaQuery.addListener(handleResizeChange)

// Initial check
handleResizeChange(mediaQuery)
